<div class="container m-b-20" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px">
  <button *ngIf="canCreateRoles()" mat-raised-button color="primary" [routerLink]="['add']">
    <fa-icon icon="plus"></fa-icon>&nbsp;&nbsp;
    {{ "ROLES.ADD_ROLE" | translate }}
  </button>
</div>

<div class="container">
  <div fxLayout="row" fxLayoutGap="20px">
    <mat-form-field fxFlex>
      <mat-label>{{ "USERS.FILTER" | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" />
    </mat-form-field>
  </div>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "ROLES.NAME" | translate }}
        </th>
        <td mat-cell *matCellDef="let role">{{ role.name }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "ROLES.DESCRIPTION" | translate }}
        </th>
        <td mat-cell *matCellDef="let role">{{ role.description }}</td>
      </ng-container>

      <ng-container matColumnDef="disabled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "USERS.STATUS" | translate }}
        </th>
        <td mat-cell *matCellDef="let role">
          <div [className]="role.disabled === true ? 'false' : 'true'">
            <fa-icon matTooltip="{{
                role.disabled === true
                  ? ('ROLES.DISABLED' | translate)
                  : ('ROLES.ENABLED' | translate)
              }}" matTooltipPosition="right" icon="circle" size="lg"></fa-icon>
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "COMMON.ACTIONS" | translate }}
        </th>
        <td mat-cell *matCellDef="let role;">
          <button *ngIf="role.name !== 'Super user'" mat-icon-button color="primary" (click)="routeEdit($event)"
            [routerLink]="[role.id, 'edit']">
            <fa-icon icon="edit">{{ "ROLES.EDIT_ROLE" | translate }}</fa-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="select-row" (click)="viewRole(row.id)" style="cursor: pointer;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>